import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-table-sub-header',
  template: '<ng-content />',
  styleUrls: ['table-sub-header.component.scss']
})
export class TableSubHeaderComponent {

}
